import axios from 'axios'
import msalInstance from '../auth/msalInstance'
import { loginRequest } from '../auth/msalConfig'

const jwtInterceptor = axios.create({ baseURL: '/api' })

jwtInterceptor.interceptors.request.use(async (config) => {
  // Lazy require breaks the store → api → jwtInterceptor → store circular dependency
  const store = require('../store/index').default
  let idToken = store.getters.idToken

  if (!idToken) {
    const accounts = msalInstance.getAllAccounts()
    if (accounts.length > 0) {
      try {
        const result = await msalInstance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0],
        })
        idToken = result.idToken
        store.commit('SET_ID_TOKEN', idToken)
      } catch {
        // Silent refresh failed — log out and abort the request entirely.
        // Returning config without a token would send an unauthenticated request
        // and trigger the 401 response interceptor, causing a retry loop.
        store.dispatch('logOut')
        return Promise.reject(new axios.Cancel('Session expired'))
      }
    }
  }

  if (idToken) {
    config.headers['Authorization'] = `Bearer ${idToken}`
  }

  return config
})

jwtInterceptor.interceptors.response.use(
  (response) => response,
  async (error) => {
    // Guard against retrying a request that already went through token refresh,
    // which would cause an infinite loop if the backend keeps returning 401.
    if (error.response?.status === 401 && !error.config._retried) {
      error.config._retried = true
      const store = require('../store/index').default
      const accounts = msalInstance.getAllAccounts()
      if (accounts.length > 0) {
        try {
          const result = await msalInstance.acquireTokenSilent({
            ...loginRequest,
            account: accounts[0],
          })
          store.commit('SET_ID_TOKEN', result.idToken)
          error.config.headers['Authorization'] = `Bearer ${result.idToken}`
          return jwtInterceptor(error.config)
        } catch {
          store.dispatch('logOut')
        }
      } else {
        store.dispatch('logOut')
      }
    }
    return Promise.reject(error)
  }
)

export default jwtInterceptor
